// @flow

import React from 'react';

type FieldErrorProps = {
  className?: string,
  message: string,
};

const FieldError = ({ className, message }: FieldErrorProps) => (
  <ul className={className}>
    <li>{message}</li>
  </ul>
);

export default FieldError;
